import React from "react";
import styles from './productos.module.css';
import CardFull from "../card/full";
import Subtitle from "../../../../components/Subtitle";
import ProductCard from "../../../../components/ProductCard";
import Primas from '../primas';

const Productos = ({ datos, saldos, productos, tipoCambio }) => {
    const condicionOrdenamiento = (a) => {
        return a.codigoTipoProducto === 2 || a.codigoTipoProducto === 3 || a.codigoTipoProducto === 5 || a.codigoTipoProducto === 6 ? -1 : 1;
    } 
    // Ordenar productos vida primero, luego los demás  
    productos?.sort(condicionOrdenamiento);

    return (
        <div className={styles.container__full}>
            <CardFull>
                <Subtitle sname="Los productos que protegerán a tu familia son:" mostrar="true" />
                <div className={styles.container__wrapper}>
                    <div className={styles.descripCard}>
                        Conoce el detalle de los productos cotizados
                    </div>
                    {/* PRODUCTOS */}
                    <div className={styles.productsContainer} style={{ marginLeft: '16px' }}>
                        {productos && productos.map((item, index) => {
                            return <ProductCard
                                producto={item}
                                tipoCambio={tipoCambio}
                                key={index} />
                        })}
                    </div>

                    {/* PRIMAS */}
                    {datos &&
                        <Primas
                            data={datos}
                            retorno={saldos}
                            tipoCambio={tipoCambio}
                        />
                    }
                </div>
            </CardFull>
        </div>
    )
}

export default Productos;
